import React from 'react';
import { Loader2 } from 'lucide-react';

// "Showing 500 of 1,243 open deals" with a Load more button; renders nothing once there is no
// next page. `shown` / `total` / `hasMore` come from the board's paging counters (see paging.js).
// A card removed since the first page can leave `total` below `shown`, so the count never exceeds it.
export default function LoadMoreBar({ shown, total, hasMore, noun = 'deals', loading = false, onMore }) {
  if (!hasMore) return null;
  const all = total || shown;
  const count = Math.min(shown, all);
  return (
    <div className="flex items-center gap-3 text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 mb-4" data-testid="pipeline-more-bar">
      <span data-testid="pipeline-more-status">Showing {count.toLocaleString('en-US')} of {all.toLocaleString('en-US')} {noun}</span>
      <button type="button" onClick={onMore} disabled={loading} className="btn-outline ml-auto" data-testid="pipeline-load-more">
        {loading && <Loader2 className="animate-spin" size={14} />} Load more
      </button>
    </div>
  );
}
